//@ts-nocheck
import React, { useState } from "react";
import styles from "./ActionsAndData.module.scss";
import EditActionsAndData from "./EditActionsAndData/EditActionsAndData";
import { Button } from "@factorearth/component-library";
import DrawerTutorialButton from "components/DrawerTutorial/DrawerTutorialButton/DrawerTutorialButton";

function ActionsAndData(props) {
	const {
		actionTypeList,
		actionDataList,
		color,
		handleChange,
		handleShowDeleteModal,
		handleSubmit,
		actionProp,
		dataProp,
		templateData,
		setupDrawer,
		fromTable,
	} = props;

	const [expanded, setExpanded] = useState(false);
	const [currentExportActions, setCurrentExportActions] = useState(actionTypeList || []);
	const [currentExportData, setCurrentExportData] = useState(actionDataList || []);
	const [edit, setEdit] = useState(null);

	/**
	 * This handles rendering the list of actions
	 * @returns {JSX.Element} HTML for the actions and data list.
	 */
	function renderActions() {
		const items = [];
		for (let i = 0; i < currentExportActions.length; i++) {
			const exportAction = currentExportActions[i];
			const exportActionData = currentExportData[i];

			const actionListItemHtml = (
				<li className={styles.action_list_item} data-test={`action-element-at-index-${i}`} key={`action-element-${exportAction}-${exportActionData}`}>
					<div className={styles.action_list_item_text}>{exportAction && exportAction !== "" ? exportAction : "New Action"}</div>
					<Button
						onClick={() => handleEditAction(exportAction, exportActionData, i)}
						className={styles.action_list_item_btn}
						colorPalette={color}
						data-test="edit-action-list-item">
						Edit
					</Button>
					<Button
						onClick={() => handleRemoveClick(i)}
						className={styles.action_list_item_btn}
						colorPalette={color}
						data-test="delete-action-list-item">
						Delete
					</Button>
				</li>
			);

			items.push(actionListItemHtml);
		}

		const final = (
			<ul className={styles.action_list} data-test="actions-ul">
				{items}
			</ul>
		);
		return final;
	}

	/**
	 * setup a new action in this component and thus children's state
	 */
	function handleNew() {
		const actionsCopy = [...currentExportActions];
		const dataCopy = [...currentExportData];

		actionsCopy.push("");
		dataCopy.push("");
		setCurrentExportActions(actionsCopy);
		setCurrentExportData(dataCopy);
	}

	/**
	 * Handles deleting an action and maintaining the state of the arrays.
	 * @param i index of the action / export action to remove.
	 * @returns {void}
	 */
	function handleRemove(i: number) {
		const actionsCopy = [...currentExportActions];
		const dataCopy = [...currentExportData];

		// Need to remove the correct one via index.
		actionsCopy.splice(i, 1);
		dataCopy.splice(i, 1);

		const changeData = {
			[actionProp]: actionsCopy,
			[dataProp]: dataCopy,
		};

		handleChange(changeData);
		setCurrentExportActions(actionsCopy);
		setCurrentExportData(dataCopy);
	}

	/**
	 * Handles setting up an action to be edited.
	 * @param action string that is being edited
	 * @param data string that is being edited.
	 * @param i index of the action and data in theri arrays
	 */
	function handleEditAction(action, data, i) {
		const obj = { [actionProp]: action, [dataProp]: data, index: i };
		setEdit(obj);
	}

	/**
	 * Handles state of expanded for the action editor.
	 */
	function toggleExpand() {
		setExpanded(!expanded);
	}

	/**
	 * Lifts the state up another level.
	 * @param data action data
	 * @param index of the action in the arrays.
	 */
	function handleSubmitItem(data, index) {
		const copyActions = [...currentExportActions];
		const copyData = [...currentExportData];
		copyActions[index] = data[actionProp];
		copyData[index] = data[dataProp];

		const changeData = {
			[actionProp]: copyActions,
			[dataProp]: copyData,
		};
		handleChange(changeData);
		setCurrentExportActions(copyActions);
		setCurrentExportData(copyData);
	}

	function handleRemoveClick(i) {
		handleShowDeleteModal(() => handleRemove(i), currentExportActions[i] !== "" ? currentExportActions[i] : "New Action");
	}

	return (
		<div className={styles.wrapper}>
			{expanded ? (
				<div className={styles.open_row}>
					{edit !== null ? (
						<div className={styles.view_wrapper}>
							<EditActionsAndData
								actionData={edit[dataProp]}
								actionProp={actionProp}
								actionType={edit[actionProp]}
								dataProp={dataProp}
								index={edit.index}
								color={color}
								templateData={templateData}
								handleSubmit={handleSubmitItem}
								handleCancel={() => setEdit(null)}
							/>
						</div>
					) : (
						<div className={styles.view_wrapper}>
							<div className={styles.action_list_wrapper}>{renderActions()}</div>
							<div className={styles.btn_wrapper}>
								<Button colorPalette={color} onClick={handleNew} className={styles.action_list_item_btn} data-test="create-new-action">
									Create New Action
								</Button>
								<Button
									colorPalette={color}
									color={color.utils.error}
									className={styles.btn}
									onClick={toggleExpand}
									data-test="close-actions-editor">
									Close {actionProp === "exportActions" ? "Export " : null}Actions Editor
								</Button>
							</div>
						</div>
					)}
				</div>
			) : (
				<div className={styles.closed_row}>
					<Button
						colorPalette={color}
						className={styles.btn}
						onClick={toggleExpand}
						data-test={`open-${actionProp === "action" ? "actions" : "export-actions"}${fromTable ? "-cell" : ""}`}>
						Open {actionProp === "action" ? "Actions" : "Export Actions"} Editor
					</Button>
					<DrawerTutorialButton
						helpColor={color.utils.success}
						location={"template-manager-actions"}
						setupDrawer={setupDrawer}
						style={{ border: "0px" }}
					/>
				</div>
			)}
		</div>
	);
}

export default ActionsAndData;
